import { useState, MouseEvent, useEffect } from "react";
import { MetadataMenuItemType } from "../../utils/dataFormattingFns"
import { ReactComponent as InfoIcon } from '../../assets/Icons/adornments/Info.svg';
import { ReactComponent as MenuOpenIcon } from '../../assets/Icons/adornments/MenuOpen.svg';
import Buttons from "../Buttons/Buttons";
import { Drawer } from "@mui/material";
import PopupHeader from "../Popups/PopupHeader";
import MenuTabs from "../Tabs/MenuTabs";
import MetadataMenuItem from "./MetadataMenuComponents/MetadataMenuItem";


export default function UpdatedMetadataMenu({
    menuLabel,
    menuItems,
    location,
    updateFunc,
}: {
    menuLabel: string,
    menuItems: MetadataMenuItemType[],
    location: 'page' | 'header',
    updateFunc?: (name: string, value: any) => Promise<void>,
}) {
    const [ open, setOpen ] = useState(false);
    const [ selectedIndex, setSelectedIndex ] = useState(0);
    const [ tabs, setTabs ] = useState<string[]>([]);

    useEffect(() => {
        if (menuItems.length > 0) {
            setTabs(menuItems.map(item => item.label));
        }
    }, [menuItems]);


    const toggleDrawer = (isOpen: boolean) => {
        setOpen(isOpen);
    }

    const handleTabChange = (event: React.SyntheticEvent, index: number) => {
        setSelectedIndex(index);
    }

    return (
        <>
        {location === 'page' ? (
            <Buttons 
                id='updated-view-metadata-btn'
                type="secondary"
                styling="solid"
                label="View Metadata"
                startingAdornment=<InfoIcon/>
                action={(e: MouseEvent<HTMLButtonElement>) => toggleDrawer(true)}
            />
        ) : (
            <button onClick={(e: MouseEvent<HTMLButtonElement>) => toggleDrawer(true)} className="w-[18px] text-disable hover:text-primary">
                <MenuOpenIcon/>
            </button>
        )}
        
        <Drawer
            anchor="right"
            open={open}
            onClose={() => toggleDrawer(false)}
        >
            <div className="w-[450px] h-full flex flex-col justify-start items-stretch bg-white rounded-tl-2xl rounded-bl-2xl">
                <PopupHeader 
                    label={menuLabel}
                    hasOutline={false}
                    collapseFn={(e: MouseEvent<HTMLButtonElement>) => toggleDrawer(false)}
                />
                <div>
                    <MenuTabs 
                        tabs={tabs.map((tab,i) => ({
                            label: tab,
                            index: i
                        }))}
                        selectedIndex={selectedIndex}
                        handleTabChange={handleTabChange}
                    />
                </div>
                {menuItems.map((menuItem, i) => {
                    const { metadata } = menuItem;
                    if (i === selectedIndex) {
                        return (
                            <div key={i} className="grow overflow-y-auto">
                                <div className="grid grid-cols-2 auto-rows-auto gap-x-6 gap-y-8 p-6">
                                    {metadata.map((metadataItem, index) => (
                                        <MetadataMenuItem 
                                            metadataItem={metadataItem}
                                            index={index}
                                            updateFunc={updateFunc}
                                        />
                                    ))}
                                </div>
                            </div>
                        )
                    } else {
                        return null;
                    }
                })}
            </div>
        </Drawer>

        </>
    )
}